/**
 * Confirms deletion of an empty custom stage (the only deletable kind).
 */

import { useTranslation } from 'react-i18next';
import { ConfirmationDialog } from '@/components/ui/ConfirmationDialog';

export interface DeleteStageDialogProps {
  /** Display name of the stage pending deletion; null when closed. */
  stageLabel: string | null;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeleteStageDialog({
  stageLabel,
  isDeleting,
  onCancel,
  onConfirm,
}: DeleteStageDialogProps) {
  const { t } = useTranslation(['job', 'common']);

  return (
    <ConfirmationDialog
      isOpen={stageLabel !== null}
      onClose={onCancel}
      title={t('job:stage_management.delete_title')}
      message={t('job:stage_management.delete_message', { name: stageLabel ?? '' })}
      closeLabel={t('common:actions.cancel')}
      buttons={[
        {
          label: t('common:actions.cancel'),
          onClick: onCancel,
          type: 'outlined',
          intent: 'secondary',
          disabled: isDeleting,
        },
        {
          label: t('common:actions.delete'),
          onClick: onConfirm,
          type: 'contained',
          intent: 'danger',
          loading: isDeleting,
          disabled: isDeleting,
        },
      ]}
    />
  );
}
